import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { AnimatedText } from '../AnimatedText';
import { LOADING_CONFIGS } from '../../constants/loadingTexts';

import loadingGif from '../../../../assets/gif/loading-audio-transcription.gif';

interface TranscriptionLoadingProps {
  isMobile?: boolean;
}

function TranscriptionLoading({ isMobile = false }: TranscriptionLoadingProps) {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="white"
      borderRadius={isMobile ? '0' : '16px'}
      display="flex"
      flexDirection={'column'}
      alignItems="center"
      justifyContent={isMobile ? 'center' : 'space-between'}
      paddingTop={isMobile ? '0' : '48px'}
      paddingBottom={isMobile ? '0' : '48px'}
      zIndex="10"
    >
      <VStack spacing="16px">
        <img src={loadingGif} alt={'loading'} width={'100px'} draggable="false" />
        <AnimatedText
          texts={LOADING_CONFIGS.transcription.texts}
          interval={LOADING_CONFIGS.transcription.interval}
          loop={false}
          fontSize="18px"
          fontWeight="400"
          color="#868E96"
          textAlign="center"
          className="pulse"
        />
      </VStack>
      {!isMobile && (
        <Box pb="16px">
          <Text fontSize="12px" color="gray.400" textAlign="center">
            Powered by Nuvie
          </Text>
        </Box>
      )}
    </Box>
  );
}

export { TranscriptionLoading };
